import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "@/config/firebase";
import { DateTime } from "luxon";
import { Timesheet } from "@otw/models";

interface GetTimesheetsParams {
  userId: string;
  clients: any[];
  projects: any[];
  projectAssignments: any[];
}

export const getTimesheets = async ({
  userId,
  clients,
  projects,
  projectAssignments,
}: GetTimesheetsParams): Promise<Timesheet[]> => {
  const timesheetsRef = collection(db, "timesheets");

  const q = query(timesheetsRef, where("userId", "==", userId));

  const querySnapshot = await getDocs(q);

  if (querySnapshot.empty) {
    return [];
  }

  const timesheets = querySnapshot.docs.map((doc) => {
    const timesheet = doc.data() as Timesheet;
    
    return {
      ...timesheet,
      id: doc.id,
    };
  });

  return timesheets.sort((a, b) => {
    const dateA = DateTime.fromISO(a.date);
    const dateB = DateTime.fromISO(b.date);
    if (dateA.equals(dateB)) {
      const startTimeA = DateTime.fromISO(a.startTime);
      const startTimeB = DateTime.fromISO(b.startTime);
      return startTimeB.toMillis() - startTimeA.toMillis();
    }
    return dateB.toMillis() - dateA.toMillis();
  });
};
